export { PhotoModel } from './photo.mdl';
export { PhotoListModel } from './photoList.mdl';
export { CustomPhoto } from './customPhoto.mdl'


// WEBPACK FOOTER //
// ./src/common/models/index.ts